import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import ReactWOW from "react-wow";
import SwiperCore, { Autoplay, Navigation, Grid, Pagination, Lazy } from 'swiper';
import { $t } from '@/modules/i18n';
import leftArrow from '@/assets/images/left-arrow.svg';
import rightArrow from '@/assets/images/right-arrow.svg';
import { getPartnerDataRequest } from '@/modules/request';
import PartnerPagination from '@/modules/Pagination';
import { isMiniScreen } from '@/utils/helper';
import 'swiper/swiper-bundle.min.css';
import '@/assets/scss/components/swiperPartner.scss';

SwiperCore.use([Autoplay, Grid, Navigation, Lazy]);


const pcOuterSwiperGrid = {
  'rows': 2
} 

const mobileOuterSwiperGrid = {
  'fill': 'row',
  'rows': 1
} 

const Partner = ({ image, name, link, defaultName }) => {
  const tName = $t(name);
  const imgUrl = image || '';
  return (
    <ReactWOW animation="fadeInUp" delay="0.1s">
      <div className="logo-container">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          {
            image ? (
              <img data-src={imgUrl} alt={tName} className="swiper-lazy img-logo" />
            ) : (
                <p className="no-logo">{tName || defaultName}</p>
              )
          }
          <p className="name">{tName || defaultName}</p>
        </a>
      </div>
    </ReactWOW>
  )
}

const PcSwiper = ({ partners }) => {
  const [swiperDom, setSwiperDom] = useState(null);
  const [typeSwiperDoms, setTypeSwiperDoms] = useState([]);
  const [innerPartners, setInnerPartners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();


  const preClick = (index) => {
    const swiper = typeSwiperDoms[index];
    if(swiper) {
      swiper.slidePrev(1000);
    }
  }

  const nextClick = (index) => {
    const swiper = typeSwiperDoms[index];
    if(swiper) {
      swiper.slideNext(1000);
    }
  }

  useEffect(() => {
    if(partners && partners.length > 0) {
      const innerPartner = partners.slice(1);
      setTotalPage(Math.ceil(innerPartner.length / 2));
      setInnerPartners(innerPartner);
    }
  }, [partners]);

  useEffect(() => {
    if(swiperDom) {
      swiperDom.slideTo(currentPage - 1, 1000);
    }
    const start = (currentPage - 1) * 2;
    const end = (currentPage) * 2;
  }, [currentPage, innerPartners]);

  return (
    <>
      {
        innerPartners.length > 0 ? (
          <Swiper
            className="partner-type-out-swiper"
            allowTouchMove={false}
            slidesPerView={1}
            grid={pcOuterSwiperGrid}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            lazy={true}
            onSwiper={(swiper) => setSwiperDom(swiper)}
            onSlideChange={(swiper) => setCurrentPage(swiper.activeIndex + 1)}
          >
            {
              innerPartners.map((partner, index) => {
                return (
                  <SwiperSlide key={index} className="partner-type-container swiper-lazy">
                    <h3 className="partner-type-title">{partner.defaultTitle}</h3>
                    <Swiper
                      height={100}
                      key={index}
                      className="partner-type-swiper"
                      modules={[Navigation, Pagination]}
                      spaceBetween={32}
                      lazy={{
                        loadPrevNext: true
                      }}
                      slidesPerView={6}
                      slidesPerGroup={2}
                      // navigation={{
                      //   prevEl: '.my-swiper-button-prev',
                      //   nextEl: '.my-swiper-button-next',
                      //   hideOnClick: true
                      // }}
                      onSwiper={(swiper) => {typeSwiperDoms[index] = swiper; setTypeSwiperDoms(Array.from(typeSwiperDoms))}}
                    >
                      {
                        partner.logos.map((logo, index) => {
                          return (
                            <SwiperSlide key={index} className="partner-slide">
                              <Partner
                                name={logo.name}
                                image={logo.image}
                                link={logo.link}
                                defaultName={logo.defaultName}
                                key={index}></Partner>
                            </SwiperSlide>
                          )
                        })
                      }
                    </Swiper>
                    <div className="my-swiper-button-prev">
                      <img onClick={() => preClick(index)} src={leftArrow} />
                    </div>
                    <div className="my-swiper-button-next">
                      <img onClick={() => nextClick(index)} src={rightArrow} />
                    </div>
                  </SwiperSlide>
                )
              })
            }
            <PartnerPagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}>
            </PartnerPagination>
          </Swiper>
        ) : null
      }
    </>
  )
}

const MobileSwiper = ({ partners }) => {
  const [swiperDom, setSwiperDom] = useState(null);
  const [typeSwiperDoms, setTypeSwiperDoms] = useState([]);
  const [innerPartners, setInnerPartners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();

  useEffect(() => {
    if(partners && partners.length > 0) {
      const innerPartner = partners.slice(1);
      setTotalPage(innerPartner.length);
      setInnerPartners(innerPartner);
    }
  }, [partners]);

  const preClick = (index) => {
    const swiper = typeSwiperDoms[index];
    if(swiper) {
      swiper.slidePrev(1000);
    }
  }

  const nextClick = (index) => {
    const swiper = typeSwiperDoms[index];
    if(swiper) {
      swiper.slideNext(1000);
    }
  }

  useEffect(() => {
    if(swiperDom) {
      swiperDom.slideTo(currentPage - 1, 1000);
    }
    const start = (currentPage - 1) * 2;
    const end = (currentPage) * 2;
  }, [currentPage, innerPartners]);

  return (
    <>
      {
        innerPartners.length > 0 ? (
          <Swiper
            className="partner-type-out-swiper"
            allowTouchMove={false}
            slidesPerView={1}
            lazy={{
              loadPrevNext: true,
              loadPrevNextAmount: 2
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            grid={mobileOuterSwiperGrid}
            onSwiper={(swiper) => setSwiperDom(swiper)}
            onSlideChange={(swiper) => setCurrentPage(swiper.activeIndex + 1)}
          >
            {
              innerPartners.map((partner, index) => {
                return (
                  <SwiperSlide key={index} className="partner-type-container">
                    <h3 className="partner-type-title">{partner.defaultTitle}</h3>
                    <Swiper
                      key={index}
                      className="partner-type-swiper"
                      modules={[Navigation, Pagination]}
                      spaceBetween={36}
                      grid={{
                        // "fill": "row",
                        "rows": 3
                      }}
                      slidesPerView={2}
                      onSwiper={(swiper) => {typeSwiperDoms[index] = swiper; setTypeSwiperDoms(Array.from(typeSwiperDoms))}}
                    >
                      {
                        partner.logos.map((logo, index) => {
                          return (
                            <SwiperSlide key={index} className="partner-slide">
                              <Partner
                                name={logo.name}
                                image={logo.image}
                                link={logo.link}
                                defaultName={logo.defaultName}
                                key={index}></Partner>
                            </SwiperSlide>
                          )
                        })
                      }
                    </Swiper>
                    <div className="my-swiper-button-prev">
                      <img onClick={() => preClick(index)} src={leftArrow} />
                    </div>
                    <div className="my-swiper-button-next">
                      <img onClick={() => nextClick(index)} src={rightArrow} />
                    </div>
                  </SwiperSlide>
                )
              })
            }
            <PartnerPagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}>
            </PartnerPagination>
          </Swiper>
        ) : null
      }
    </>
  )
}


export default ({ partners }) => {
  const [swiperDom, setSwiperDom] = useState(null);
  const [typeSwiperDoms, setTypeSwiperDoms] = useState([]);
  const [isMobile, setIsMobile] = useState(isMiniScreen());
  const [innerPartners, setInnerPartners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();

  const handleResize = () => {
    const newIsMobile = isMiniScreen();
    setIsMobile(newIsMobile);
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return (
    <>
      {
        isMobile ? (
          <MobileSwiper partners={partners}></MobileSwiper>
        ) : <PcSwiper partners={partners}></PcSwiper>
      }
    </>
  )
}